import http from './Request';
import AccordiumService from './AccordiumService';

const userAPI = process.env.USER_API;

export default class UserService extends AccordiumService {
  static getUser() {
    return http.get(`${userAPI}/user`, UserService.getHeaders()).then(response => response.data); // don't really need to convert the data here.
  }

  static getUserSubscription() {
    return http.get(`${userAPI}/user/subscription`, UserService.getHeaders()).then(response => response.data); // don't really need to convert the data here.
  }

  static getUserProfile() {
    return http.get(`${userAPI}/user/profile`, UserService.getHeaders()).then(response => response.data);
  }

  static updateUserInfo(firstName, lastName, telephone, company) {
    const body = {
      firstName,
      lastName,
      telephone,
      company,
    };
    return http.put(`${userAPI}/user/info`, body, UserService.getHeaders()).then(response => response.data);
  }

  static updateDashboardView(dashboardKind) {
    const body = {
      dashboardKind,
    };
    return http.put(`${userAPI}/user/settings/dashboard`, body, UserService.getHeaders()).then(response => response.data);
  }

  static updateOrganizationSettings(callbackURL, logoURL) {
    const body = {
      callbackURL,
      logoURL,
    };
    return http.put(`${userAPI}/user/settings/organization`, body, UserService.getHeaders()).then(response => response.data);
  }

  static updateCredential(currentPassword, newPassword) {
    const body = {
      currentPswd: currentPassword,
      newPswd: newPassword,
    };
    return http.put(`${userAPI}/user/credential`, body, UserService.getHeaders()).then(response => response.data);
  }

  static updateConsent(dataConsent, crmConsent) {
    const body = {
      dataConsent,
      crmConsent,
    };
    return http.put(`${userAPI}/user/consent`, body, UserService.getHeaders()).then(response => response.data);
  }

  static updateProfilePicture(avatarUri) {
    const body = { avatarUri };
    return http.put(`${userAPI}/user/avatar`, body, UserService.getHeaders()).then(response => response.data);
  }
}
